module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c",
    attrs: {
      "id": "frontmatter2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("FOREWORD")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Having spent my entire working life in the fly-fishing industry and the past twelve years happily immersed in international fly-fishing travel, I am one of the first to applaud works that highlight the pleasures of fishing new and sometimes distant waters. It is a broad field with an unfathomable number of venues and outfitters, not all of which are created equal. Sorting through these many options in search of the true gems is an ongoing process and a challenge I enjoy. In the same breath, I know that to do it well takes a lot of work and energy, making me all the more impressed when an author can take a topic of diversity and distil it into something as balanced, informative, and inspiring as Chris Santella’s "), _c('em', [_vm._v("Fifty More Places to Fly Fish Before You Die.")]), _vm._v(" This man clearly did his homework.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both fly fishing and travel demand a need for adventure, interest in the natural sciences, athleticism, and, above all else, an innate and irrepressible obsession for which there is no cure. When it comes to fly fishing in its purest form, and a discussion of the “World’s Greatest” fishing destinations, there will never be consensus. There are no formulas, nor absolute truths. Instead, we face a myriad of subtle choices that, on rare occasions, combine with good fortune to create fishing scenarios so special we cannot help but consider them among the most exciting and pleasurable of our earthly experiences. Though anglers may not reach consensus on the perfect “bucket list,” this volume certainly offers something for everyone—from the choosy trout of Idaho’s Silver Creek to Tasmania’s fabled tarns, the less than particular giant trevally of the Seychelles’ Outer Atolls, and the giant rainbows of Argentina’s Jurassic Lake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For fly anglers, it is this hope of being in the right place at the right time that helps us through the motions of our daily grind, wakes us happily before dawn, and compels us to travel to the far corners of the globe. It is also the inspiration for this book, an impressive collection of dream trips, carefully selected to help all those with the burning drive to travel and fish make the most of their cherished time on the water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("—K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORRISH")]), _vm._v(", F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LY")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATER")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAVEL")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("A fall angler on British Columbia’s Sustut, where any cast could connect you with a “supertanker” steelhead.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e1eb8c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter2.vue
// module id = 78
// module chunks = 0